import "./Footer.css"

const Footer = () => {
    return (
        <footer>
        <div className="footer-container">
            <div className="stores">
                <div className="store">
                    <h2>Mýtná Nová Ves</h2>
                    <div className="address">
                        <ul>
                            <li>Mýtna Nová Ves 148</li>
                            <li>956 11  Ludanice</li>
                            <li>Slovensko</li>
                        </ul>
                    </div>
                    <div className="hours"></div>
                        <h3>Otváracie hodiny</h3>
                        <ul>
                            <li>PO-SO: 9:00 - 19:00</li>
                            <li>NE: 10:00 - 19:00</li>
                        </ul>
                    <div className="contact">
                        <h3>Kontakt</h3>
                        <ul>
                            <li><img width={16} height={16} src="/data/photos/logo/phone.png" alt="phone-icon" /> <a href="tel:+421905250123">+421 905 250 123</a> </li>
                            <li><img width={16} height={16} src="/data/photos/logo/email.png" alt="email-icon" /> <a href="mailto:interstyle@gmail.com ">interstyle@gmail.com </a> </li>
                        </ul>
                    </div>
                </div>
                <div className="store">
                    <h2>Bratislava</h2>
                    <div className="address">
                        <ul>
                            <li>Ul. Svornosti 14</li>
                            <li>820 14  Bratislava</li>
                            <li>Slovensko</li>
                        </ul>
                    </div>
                    <div className="hours"></div>
                        <h3>Otváracie hodiny</h3>
                        <ul>
                            <li>PO-SO: 9:00 - 19:00</li>
                            <li>NE: 10:00 - 19:00</li>
                        </ul>
                    <div className="contact">
                        <h3>Kontakt</h3>
                        <ul>
                            <li><img width={16} height={16} src="/data/photos/logo/phone.png" alt="phone-icon" /> <a href="tel:+421917250123">+421 917 250 123</a> </li>
                            <li><img width={16} height={16} src="/data/photos/logo/email.png" alt="email-icon" /> <a href="mailto:interstyle@gmail.com ">interstyle@gmail.com </a> </li>
                        </ul>
                    </div>
                </div>
            </div> 
        </div>
        <div className="line"/>
        <h1>Copyright © 2023 INTERSTYLE. Všetky práva vyhradené.</h1>
        </footer>
    )
}

export default Footer